/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import Hotkeys from '@bingads-webui-component-legacy/hotkeys/jquery-hotkeys';
var events = {
  'keydown.ctrl_c.hotkeys': 'copy',
  'keydown.meta_c.hotkeys': 'copy',
  'keydown.ctrl_v.hotkeys': 'paste',
  'keydown.meta_v.hotkeys': 'paste'
};
var dispatcher = {
  setup: function () {
    _.each(events, function (event, key) {
      Hotkeys.bind(key, function () {
        dispatcher.trigger(event);
      });
    });
    Backbone.history.once('route', function () {
      this.reset();
    }, this);
  },
  reset: function () {
    _.each(events, function (event, key) {
      Hotkeys.unbind(key);
    });
    this.off();
  }
};
_.extend(dispatcher, Backbone.Events);
export default dispatcher;

